import { render } from "./EdifierTenantTasks.vue?vue&type=template&id=0cd5e4ca"
import script from "./EdifierTenantTasks.vue?vue&type=script&lang=js"
export * from "./EdifierTenantTasks.vue?vue&type=script&lang=js"

import "./EdifierTenantTasks.vue?vue&type=style&index=0&id=0cd5e4ca&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__